export interface BusinessLocation {
  id: string;
  businessId: string;
  name: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zipcode?: string;
    country?: string;
  };
  phone?: string;
  timezone?: string;
  hours?: any;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const PRIMARY_LOCATION_ID = 'primary';

